<div fxLayout="row" fxLayoutGap="5px">
    <div>
        <mat-card class="dashboard-card dashboard-card-align-center">
            <mat-card-header>
                <img src="assets/DLA-1.png" class="logo"/>
            </mat-card-header>
            <mat-card-content class="dla-colors">
                <br><br>
                <mat-card-title>DLA Software Solutions</mat-card-title>
                <br>                
                Technopark 6<br>
                7102 JM Winterswijk<br>
                0543-523560<br>
                <br>
                Hanzestraat 1<br>
                7006 RH Doetinchem<br>
                <br>
                <a href="http://www.dla.nl" target="_blank" class="dla-colors">www.dla.nl</a><br>
                <a href="mailto:info@dla.nl" class="dla-colors">info@dla.nl</a><br>                
                <br>
                <br>
                <i>
                <small>
                Mi-Lab-Pro<br>
                Copyright 2021-2026<br>
                DLA Software Solutions<br>
                </small>
                </i>
                <br>
                <a href="https://www.linkedin.com/company/573168?trk=tyah" target="_blank"><img src="assets/linkedin.png" class="icon"/></a>&nbsp;
                </mat-card-content>
        </mat-card>
    </div>    
    <div>
        <mat-card class="dashboard-card-collection">
            <img [src]="currentImageSrc()" height="400px" width="750px" (click)="nextImage()" />
        </mat-card>
    </div>
    <div>
        <mat-card class="dashboard-card dashboard-card-align-center">
            <mat-card-header>
              
            </mat-card-header>
            <mat-card-content class="dla-colors">
                <h3>{{MiLabProName}}</h3>
                <p>versie {{MiLabProVersion}}</p>
                <p>{{MiLabProDate}}</p>
                <small>powered by :</small>
                <br>
                <img src="assets/mango.png" height="48px"/>
                <br>
                <h4>Client Information</h4>
                <p>{{osName}} {{osVersion}}</p>
                <p>{{browser}} {{majorversion}}<br>{{version}}</p>
                <p>{{userAgent}}</p>
                <h4>Customer Portal DLA</h4>
                <p><a href="https://www.366assist.nl" target="_blank"><img src="assets/366assist.png" class="icon"/></a></p>                
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div fxLayout="row" fxLayoutGap="5px">
    <div>
        <mat-card class="dashboard-quote dashboard-card-align-center">
            <mat-card-content class="dla-colors effect effect-a" >                
                <h4 class="effect_heading" (click)="randomQuotes()">{{ quoteText }} </h4>                
            </mat-card-content>
        </mat-card>     
    </div>
</div>
